export default __webpack_public_path__ + "static/media/3097.bcf60191.png";